import React, { Component } from "react";

export default class SearchResultRow extends Component {
  render() {
    const url =
      "/developer/userSupport/adminConsole/support/firstnet/NetPromoterScore?orgId=" +
      this.props.org.organizationId;

    return (
      <tr>
        <td>
          <a href={url}>{this.props.org.name}</a>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/firstnet/search/organization/components/SearchResultRow.js